import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Stack from '../stack/stack';

export const SubSectionContainer = styled(Stack)`
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
    background: #ffffff;
`;

const SubSectionHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const SubSectionTitle = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #263238;
`;

const SubSectionDescription = styled.div`
    font-size: 12px;
    line-height: 1.4;
    color: #78909c;
`;

const SubSectionContent = styled(Stack)``;

export const SubSection = forwardRef<
    HTMLDivElement,
    { children: React.ReactNode; className?: string; id?: string; title?: React.ReactNode; description?: React.ReactNode; contentGap?: string }
>(({ children, className, id, title, description, contentGap }, ref) => {
    const hasHeader = !!title || !!description;

    return (
        <SubSectionContainer ref={ref} className={className} id={id} $gap={hasHeader ? '12px' : undefined}>
            {hasHeader && (
                <SubSectionHeader>
                    {title && <SubSectionTitle>{title}</SubSectionTitle>}
                    {description && <SubSectionDescription>{description}</SubSectionDescription>}
                </SubSectionHeader>
            )}
            {hasHeader ? <SubSectionContent $gap={contentGap}>{children}</SubSectionContent> : children}
        </SubSectionContainer>
    );
});
